<script lang="ts" setup>
import { onMounted } from 'vue';
import { AppTypography } from '~/components/base';

const modelValue = defineModel<boolean>({ default: true });

onMounted(() => {
  modelValue.value = true;
});
</script>

<template>
  <div class="agreement-field">
    <AppTypography type="subheadline" class="text-center"
      >By continuing, you agree to our
      <NuxtLink
        :to="{ name: 'terms' }"
        class="font-bold"
        data-testid="terms-link"
        >Terms of Service</NuxtLink
      >
      and
      <NuxtLink
        :to="{ name: 'privacy-policy' }"
        class="font-bold"
        data-testid="privacy-link"
        >Privacy Policy</NuxtLink
      >.
    </AppTypography>
  </div>
</template>

<style>
.agreement-field {
}
</style>
